export default {
  title: 'Nota prawna',
  subtitle: 'Pojawia się w stopce sklepu internetowego i strony dopiero po zapisaniu.',
  card_title: 'Nota prawna',
  placeholder: 'Wpisz treść noty prawnej',
  status: {
    saved: 'Zapisano',
    not_shown: 'Jeszcze niewidoczna w sklepie ani na stronie',
    unsaved: 'Niezapisane zmiany — sklep i strona pokazują ostatnio zapisaną wersję',
  },
  save: 'Zapisz',
  retry: 'Spróbuj ponownie',
  preview: {
    title: 'Podgląd stopki (sklep i strona)',
    terms: 'Regulamin',
    privacy: 'Prywatność',
    cookies: 'Pliki cookie',
    imprint: 'Nota prawna',
  },
  toasts: {
    saved: 'Nota prawna zapisana',
    save_failed: 'Nie udało się zapisać noty prawnej. Spróbuj ponownie.',
    load_failed: 'Nie udało się wczytać noty prawnej. Odśwież stronę.',
  },
};
